import {UnitBusinessVirtualDebitCardDto} from 'src/app/shared/models/unit-card/UnitBusinessVirtualDebitCardDto.model';

export class CreateCardDialogParams {
  step: CreateUnitCardStep;
  businessCard: UnitBusinessVirtualDebitCardDto = null;

  constructor(
    step: CreateUnitCardStep,
    businessCard: UnitBusinessVirtualDebitCardDto = null) {
    this.step = step;
    this.businessCard = businessCard;
  }
}


export enum CreateUnitCardStep {
  FillDetails,
  Created
}
